import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { MeshoptDecoder } from 'three/examples/jsm/libs/meshopt_decoder.module.js';
import { formatImage } from '../../utils/index';
import { removeTreeFromScene } from '../../utils/index'
class ContainerObject {
    constructor(initData) {
        let { resource, env, id, params } = initData;
        //id
        this.id = id || 'container_' + new Date().getTime();
        //资源
        this.resource = resource;
        //环境
        this.env = env;
        //物体实例
        this.mesh = null;
        //配置项
        this.params = params || {
            //大小
            size: 1
        };
        this.defaultGlbScaleBoost = 2;
        this.baseScale = 1;
        this.radius = 0;
        this.height = 0;
        this.loader = new GLTFLoader();
        this.loader.setMeshoptDecoder(MeshoptDecoder);
        //初始化
        this.initPromise = this.init()
    }

    isGlbContainer () {
        return !!this.resource.modelFilePath;
    }

    //初始化
    async init () {
        if (this.isGlbContainer()) {
            await this.initGlbContainer();
            return;
        }
        this.initLatheContainer();
    }

    initLatheContainer () {
        for (let data of JSON.parse(JSON.stringify(this.resource.detail))) {
            let points = data.points,
                line = [];
            points.reverse();
            for (var j = 0; j < points.length; j += 20) {
                line.push(
                    new THREE.Vector2(points[j] / 16, (j - 0) / 16)
                );
            }
            for (let vec2 of line) {
                this.radius = vec2.x > this.radius ? vec2.x : this.radius;
                this.height = vec2.y > this.height ? vec2.y : this.height;
            }
            var mesh = new THREE.Mesh(new THREE.LatheGeometry(line, 60), new THREE.MeshPhysicalMaterial({
                side: 2,
                map: new THREE.TextureLoader().load(formatImage(data.map)),
            }));
            this.mesh = mesh;
            this.env.three.scene.add(mesh);
        }
        this.updateModel();
    }

    async initGlbContainer () {
        const url = formatImage(this.resource.modelFilePath);
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error(`模型文件请求失败(${response.status})`);
        }
        const buffer = await response.arrayBuffer();
        const gltf = await new Promise((resolve, reject) => {
            this.loader.parse(
                buffer,
                '',
                resolve,
                reject
            );
        });
        const root = gltf.scene || gltf.scenes?.[0];
        if (!root) {
            throw new Error('GLB container scene is empty');
        }
        root.traverse(child => {
            if (child.isMesh) {
                child.castShadow = true;
                child.receiveShadow = true;
            }
        });
        const box = new THREE.Box3().setFromObject(root);
        const size = box.getSize(new THREE.Vector3());
        const center = box.getCenter(new THREE.Vector3());
        const maxHorizontalSize = Math.max(size.x, size.z);

        // GLB 容器的建模单位和编辑器现有器皿差异很大，先归一到编辑器可见尺度。
        const targetHeight = 100;
        const targetRadius = 145.125;
        const scaleCandidates = [];
        if (size.y > 0) {
            scaleCandidates.push(targetHeight / size.y);
        }
        if (maxHorizontalSize > 0) {
            scaleCandidates.push((targetRadius * 2) / maxHorizontalSize);
        }
        this.baseScale = scaleCandidates.length ? Math.min(...scaleCandidates) : 1;
        this.baseScale *= this.defaultGlbScaleBoost;

        root.position.x -= center.x;
        root.position.z -= center.z;
        root.position.y -= box.min.y;

        this.radius = (maxHorizontalSize / 2) * this.baseScale;
        this.height = size.y * this.baseScale;
        this.mesh = root;
        this.env.three.scene.add(root);
        this.updateModel();
    }
    //更新模型
    updateModel () {
        if (!this.mesh) {
            return;
        }
        const scale = this.baseScale * this.params.size;
        this.mesh.scale.x = scale;
        this.mesh.scale.y = scale;
        this.mesh.scale.z = scale;
    }
    //移除
    remove () {
        removeTreeFromScene(this.env.three.scene, this.mesh);
        this.env.objects.container = null;
    }
}

export default ContainerObject;
